import { render } from "./NavBar.vue?vue&type=template&id=5014a797&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=5014a797&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\attituttu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5014a797"]])

export default __exports__